<template>
  <div v-if="product.purchaseDate" class="contents">
    <div class="order_info">
      <span class="order_date">
        {{ product.purchaseDate }}
      </span>
      <span class="order_num">주문번호: {{ product.purchaseNumber }}</span>
    </div>
    <div class="game_name_info">
      <span class="game_name">{{ gameName }}</span>
    </div>

    <div class="purchase_game_info_wrapper">
      <div v-for="purchaseDetail in purchaseDetails" class="purchase_game_info">
        <div class="game_name_box">
          <div class="game_text">{{ purchaseDetail.productName }}</div>
          <div class="game_info_detail">
            <div class="game_info_detail_quantity">
              {{ purchaseDetail.purchaseCount }}개
            </div>
            <div class="game_info_detail_bar"></div>
            <div class="game_info_detail_price">
              {{ purchaseDetail.purchaseAmount.addComma() }}원
            </div>
          </div>
        </div>
        <div
          v-if="purchaseDetail.purchaseFreeAmount"
          class="game_info_detail_mileage"
        >
          <span>({{ purchaseDetail.purchaseFreeAmount.addComma() }}</span>
          <span class="game_info_detail_mileage_name">
            {{ purchaseDetail.coinUnit }}
          </span>
          <span class="game_info_detail_mileage_usage">사용)</span>
        </div>
      </div>
    </div>
    <div class="purchase_game_price_info">
      <div class="price_info_detail">
        <div class="price_text">총 상품 금액</div>
        <div class="price_info_detail_price">
          {{ product.purchaseTotalAmount.addComma() }}원
        </div>
      </div>
      <div class="line"></div>
      <div class="purchase_box">
        <div class="price_info_detail">
          <div class="price_info_title">결제일시</div>
          <div class="price_info_text">{{ product.purchaseDate }}</div>
        </div>
        <div class="price_info_detail">
          <div class="price_info_title">결제번호</div>
          <div class="price_info_text">{{ product.purchaseNumber }}</div>
        </div>
        <div class="price_info_detail">
          <div class="price_info_title">결제상태</div>
          <div class="price_info_text">{{ convertPurchaseStatus }}</div>
        </div>
        <div v-if="product.purchaseFreeTotalAmount" class="price_info_detail">
          <div class="price_info_title">
            <span class="price_info_title_bold">{{ product.coinName }}</span>
            <span class="price_info_title_use">사용</span>
          </div>
          <div class="price_info_text">
            <span>{{ product.purchaseFreeTotalAmount.addComma() }}</span>
            <span class="price_info_text_use_bold">
              {{ product.coinUnit }}
            </span>
          </div>
        </div>
        <div class="price_info_detail">
          <div class="price_info_title">결제금액</div>
          <div class="price_info_text">
            <span>{{ payAmount.addComma() }}</span>
            <span class="price_info_text_user">원</span>
          </div>
        </div>
        <div v-if="payAmount !== 0" class="price_info_detail">
          <div class="price_info_title">결제수단</div>
          <div class="price_info_text">{{ product.purchaseType }}</div>
        </div>
        <div v-if="product.currency" class="price_info_detail">
          <div class="price_info_title">글로벌PG 결제통화</div>
          <div class="price_info_text">{{ product.currency }}</div>
        </div>
        <div v-if="product.totalExchangeAmount" class="price_info_detail">
          <div class="price_info_title">글로벌PG 결제금액</div>
          <div class="price_info_text">
            {{ product.totalExchangeAmount }}
          </div>
        </div>
      </div>
      <div class="gray_line"></div>
      <div v-if="hasRefund" class="refund_box">
        <div class="price_info_detail">
          <div class="price_info_title">환불일시</div>
          <div class="price_info_text">
            {{ product.refundDateTime }}
          </div>
        </div>
        <div
          v-if="product.refundFreeTotalAmount !== 0"
          class="price_info_detail"
        >
          <div class="price_info_title">
            <span class="price_info_title_refund">환불</span>
            <span class="price_info_title_bold">{{ product.coinName }}</span>
          </div>
          <div class="price_info_text">
            <span>
              {{ product.refundFreeTotalAmount.addComma() }}
            </span>
            <span class="price_info_text_use_bold">{{ product.coinUnit }}</span>
          </div>
        </div>
        <div class="price_info_detail">
          <div class="price_info_title">환불금액</div>
          <div class="price_info_text">
            <span>
              {{ refundValue.addComma() }}
            </span>
            <span class="price_info_text_use">원</span>
          </div>
        </div>
        <div v-if="refundValue > 0" class="price_info_detail">
          <div class="price_info_title">환불수단</div>
          <div class="price_info_text">{{ product.purchaseType }}</div>
        </div>
      </div>
    </div>
  </div>
  <contents-none v-else noneText="구매내역이 없습니다."></contents-none>
</template>

<script>
import { mapGetters } from 'vuex'
import ContentsNone from '@/views/base/ContentsNone'

export default {
  name: 'AlltemPurchaseDetail',
  components: {
    ContentsNone
  },
  props: {},
  data() {
    return {
      product: this.$route.params,
      purchaseDetails: this.$route.params.purchaseDetails
    }
  },
  computed: {
    ...mapGetters('main', [
      'enableReward',
      'enableCart',
      'paymentSystemType',
      'name',
      'gameName'
    ]),
    convertPurchaseStatus() {
      switch (this.product.purchaseStatus) {
        case 0:
          return '롤백'
        case 1:
          return '요청'
        case 2:
          return '결제승인완료'
        case 3:
          return '정상구매'
        case 4:
          return '환불'
        case 5:
          return '부분환불'
        default:
          return '알 수 없음'
      }
    },
    payAmount() {
      if (this.product.purchaseType === '넥슨캐시') {
        return this.product.purchaseTotalAmount
      }

      return this.product.purchasePaidTotalAmount
    },
    refundValue() {
      if (this.product.refundFreeTotalAmount > 0) {
        return (
          this.product.refundTotalAmount - this.product.refundFreeTotalAmount
        )
      }

      return this.product.refundTotalAmount
    },
    hasRefund() {
      return (
        this.product.purchaseStatus === 4 || this.product.purchaseStatus === 5
      )
    }
  },
  methods: {},
  mounted() {
    if (
      this.purchaseDetails === undefined ||
      this.purchaseDetails.length === 0
    ) {
      history.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.order_info {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px 10px 16px;
  background-color: white;
  border-bottom: 1px solid #d6d6db;
  font-family: 'Noto Sans KR';
  font-size: 14px;
  .order_date {
    font-weight: bold;
    color: #151721;
  }
  .order_num {
    color: #636376;
  }
}
.game_name_info {
  display: flex;
  font-family: 'Noto Sans KR';
  background-color: white;
  .game_name {
    padding: 10px 0px 0px 16px;
    font-size: 13px;
    font-weight: bold;
    color: #151721;
  }
}
.purchase_game_info_wrapper {
  background-color: white;
  padding-bottom: 12px;
  .purchase_game_info {
    padding: 12px 16px 0 16px;
    font-family: 'Noto Sans KR';
    background-color: white;
    // border-bottom: 1px solid #ededed;

    .game_name_box {
      display: flex;
      justify-content: space-between;
      // margin: 12px 0;
      .game_text {
        font-size: 15px;
        color: #151721;
      }
      .game_info_detail {
        display: flex;
        align-self: center;
        .game_info_detail_quantity {
          font-size: 13px;
          color: #636376;
        }
        .game_info_detail_price {
          font-size: 15px;
          font-weight: bold;
          color: #151721;
        }
        .game_info_detail_bar {
          width: 1px;
          height: 10px;
          margin: 0 6px;
          background-color: #a5a5ac;
        }
      }
    }
    .game_info_detail_mileage {
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      margin: 7px 0;
      .game_info_detail_mileage_name {
        margin-left: 3px;
        font-weight: bold;
      }
      .game_info_detail_mileage_usage {
        margin-left: 3px;
      }
    }
  }
}

.purchase_game_price_info {
  margin-top: 11px;
  padding: 10px 16px;
  font-family: 'Noto Sans KR';
  background-color: white;
  .price_info_detail {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .price_text {
      font-size: 15px;
      color: #151721;
    }
    .price_info_detail_price {
      font-size: 17px;
      font-weight: bold;
      color: #6134f1;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    margin: 10px 0 16px 0;
    background-color: #636376;
  }
  .gray_line {
    width: 100%;
    height: 1px;
    margin: 16px 0;
    background-color: #d6d6db;
  }
  .price_info_title {
    font-size: 14px;
    color: #636376;
  }
  .price_info_title_bold {
    font-weight: bold;
  }
  .price_info_title_refund {
    margin-right: 3px;
  }
  .price_info_title_use,
  .price_info_text_use {
    margin-left: 3px;
  }
  .price_info_text_use_bold {
    font-weight: bold;
  }
  .price_info_text {
    font-size: 14px;
    color: #151721;
  }
}
</style>
